import Cookies from "js-cookie";
import axios from "../../../axios";

export const AIReport = async (payload) => {
	return axios.post("/api/Report/GetTaskSummarybyDateRange", payload);
};

export const DailyTaskAIReport = async (payload) => {
	return axios.post("/api/Report/GetTaskExcelTaskSummary", payload);
};

const getAuthConfig = () => {
	const token = Cookies.get("Orbit_Token") || localStorage.getItem("token");

	return {
		headers: token
			? {
					Authorization: `Bearer ${token}`,
			  }
			: undefined,
	};
};

export const GetYearlyTaskReport = async (payload) => {
	return axios.post(
		"/api/Report/GetYearlyTaskReport",
		payload,
		getAuthConfig()
	);
};

export const GetUserWiseYearlyTaskReport = async (payload) => {
	return axios.post(
		"/api/Report/GetUserWiseYearlyTaskReport",
		payload,
		getAuthConfig()
	);
};

export const GetAllUsers = () => {
	const token = localStorage.getItem("token");

	return axios.get("/api/Admin/GetAllUsers", {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
};
